module.exports = __webpack_public_path__ + "static/media/logo.c8c9070f.svg";